<script>
/**
 * Type         : Page component
 * Title        : 데이터백업 페이지 컴포넌트
 * Description  : 데이터백업을 관리한다
 * 
 */

import Title from "@/components/admin/common/TitleArea.vue"
import CodeRegForm from "@/components/admin/common/modal/CodeRegiFormUnit.vue"

export default {
  name: "AdminCodeManagement",
  meta: {
    title: "어드민-데이터백업"
  },
  components: {
    Title,
    CodeRegForm,
  },
  data() {
    return {
      description   : {
        title       : '데이터백업'
      },
      files: [],
      folderName: 'backup', // 백업 폴더 이름. backup, uploads, failed
    }
  },
  /*
  setup(){
  }
  */

  methods: {
    /**
     * Get backup file list
     * 
     * Description
     * - 로컬에서는 백업 폴더가 없기 때문에 경로가 달라 화면을 불러올 수 없어 express에서 로컬 uploads 폴더를 임시로 사용함
     */
     async getBackupFileList () {
      try {

        let config = {
          method  : "POST",
          url     : "/api/admin/getBackupList",
          data    : { folderName : this.folderName },
          name    : "[ Axios / Lab / 백업파일 목록 ]"
        }

        await this.$http(config)
          .then((res) => {
            this.$log.debug("불러온 파일 목록 = ", res)
            this.files = res.data.fileDetails
          })
          .catch((err) => {
            this.$log.debug(err)
            alert('불러오기 실패!')
        })

      } catch (error) {
        this.$log.error("파일 목록을 가져오는 중 오류 발생:", error);
      }
      return 
    }



    /**
     * Change folder name
     * 
     * Description
     * - 백업 폴더 이름을 변경하고 해당 폴더의 파일 목록을 불러온다
     * - folderName: 'backup', 'uploads', 'failed'
     */
    , chageFolderName(folderName) {
      this.folderName = folderName
      this.getBackupFileList()
    }
  },
  
  mounted() {
    this.$log.info("[ Page / 데이터백업 ]")
    this.getBackupFileList()
  },
}
</script>


<template>
  
  <q-page class="q-pa-lg">
    <div class="row">
      <div class="col">
        <Title
          :desc="description">
          <q-btn-group>
            <q-btn
              :color="folderName === 'backup' ? 'primary': 'grey'"
              size="md"
              label="백업파일목록"
              @click="() => { chageFolderName('backup'); description.title = '백업파일목록'}"/>
            <q-btn
              :color="folderName === 'uploads' ? 'secondary': 'grey'"
              size="md"
              label="업로드엑셀목록"
              @click="() => { chageFolderName('uploads'); description.title = '업로드엑셀목록'}"/>
            <q-btn
              :color="folderName === 'failed' ? 'info': 'grey'"
              size="md"
              label="실패엑셀목록"
              @click="() => { chageFolderName('failed'); description.title = '실패엑셀목록'}"/>
          </q-btn-group>
        </Title>  
      </div>
    </div>

    <div class="row q-mt-lg">
      <div class="col">
        <div class="comp-box">

          <q-list bordered class="rounded-borders">
            <q-item-label header>📂 {{ description.title }}</q-item-label>

            <div v-for="(file, index) in files" :key="index">
              <q-item>
                <q-item-section>
                  <q-item-label lines="1">
                    <span class="text-weight-medium">{{ file.filename }}</span>
                  </q-item-label>
                  <q-item-label caption>
                    <span class="text-weight-lignt">{{ this.$formatDate(file.createdAt, "xxxx년 xx월 xx일") }}</span>
                  </q-item-label>
                </q-item-section>

                <q-item-section side>
                  <div class="text-grey-8 q-gutter-xs">
                    <q-btn :href="`/api/admin/files/${folderName}/${file.filename}`" class="gt-xs" size="12px" flat dense round icon="download" />
                  </div>
                </q-item-section>
              </q-item>
            </div>

          </q-list>

        </div>
      </div>
    </div>
  </q-page>
  

  <teleport to="body">

    <q-dialog 
      v-model="showModalNow">

      <CodeRegForm
        @add-item="regiCode"
      />

    </q-dialog>

  </teleport>

</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
